import {Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {AccountingOfficeService} from './accounting-office.service';
import {Company} from 'patja-api';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  private companies: WritableSignal<Company[]> = signal([]);
  private selectedCompany: WritableSignal<Company | null> = signal(null);

  constructor(private accountingOfficeService: AccountingOfficeService) {}

  getCompanies(): Signal<Company[]> {
    return this.companies.asReadonly();
  }

  getSelectedCompany(): Signal<Company | null> {
    return this.selectedCompany.asReadonly();
  }

  setCompanies(companies: Company[]): void {
    this.companies.set(companies);
    this.selectCompany();
  }

  setSelectedCompany(company: Company | null): void {
    this.selectedCompany.set(company);
    if (company) {
      localStorage.setItem('patja_selected_company_id', company.id);
    }
  }

  selectCompany(company?: Company): void {
    if (company) {
      this.setSelectedCompany(company);
    } else {
      const companyIdToSelect: string | null = localStorage.getItem('patja_selected_company_id');
      if (companyIdToSelect) {
        const companyToSelect: Company | undefined = this.companies().find(
          (company: Company) => company.id === companyIdToSelect,
        );
        this.setSelectedCompany(companyToSelect || this.companies()[0] || null);
      } else if (this.companies().length) {
        this.setSelectedCompany(this.companies()[0]);
      } else {
        this.setSelectedCompany(null);
      }
    }

    if (this.selectedCompany()) {
      this.accountingOfficeService
        .fetchAccountingOfficeForCompany(this.selectedCompany()!.id)
        .subscribe();
    }
  }
}
